"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icons = exports.FollowUsRoot = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const FollowUsRoot = exports.FollowUsRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  maxWidth: _constants.maxWidth,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2)
}));
const Icons = exports.Icons = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: theme.spacing(2)
}));
